import { render, staticRenderFns } from "./AgrRecord.vue?vue&type=template&id=6e7a12b7&scoped=true&"
import script from "./AgrRecord.vue?vue&type=script&lang=js&"
export * from "./AgrRecord.vue?vue&type=script&lang=js&"
import style0 from "./AgrRecord.vue?vue&type=style&index=0&id=6e7a12b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7a12b7",
  null
  
)

export default component.exports